import { render, staticRenderFns } from "./GenericSingle.vue?vue&type=template&id=3279efa4&"
import script from "./GenericSingle.vue?vue&type=script&lang=js&"
export * from "./GenericSingle.vue?vue&type=script&lang=js&"
import style0 from "./GenericSingle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VContainer,VDivider,VIcon})
